/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiAdminDtoIntegrationSyncSummaryDto } from './WebApiAdminDtoIntegrationSyncSummaryDto';
import {
    WebApiAdminDtoIntegrationSyncSummaryDtoFromJSON,
    WebApiAdminDtoIntegrationSyncSummaryDtoFromJSONTyped,
    WebApiAdminDtoIntegrationSyncSummaryDtoToJSON,
} from './WebApiAdminDtoIntegrationSyncSummaryDto';
import type { WebApiAdminDtoRecentSyncRunDto } from './WebApiAdminDtoRecentSyncRunDto';
import {
    WebApiAdminDtoRecentSyncRunDtoFromJSON,
    WebApiAdminDtoRecentSyncRunDtoFromJSONTyped,
    WebApiAdminDtoRecentSyncRunDtoToJSON,
} from './WebApiAdminDtoRecentSyncRunDto';
import type { WebApiAdminDtoStaleIntegrationDto } from './WebApiAdminDtoStaleIntegrationDto';
import {
    WebApiAdminDtoStaleIntegrationDtoFromJSON,
    WebApiAdminDtoStaleIntegrationDtoFromJSONTyped,
    WebApiAdminDtoStaleIntegrationDtoToJSON,
} from './WebApiAdminDtoStaleIntegrationDto';

/**
 * Integration sync run activity - built from IntegrationSyncCompleted/Failed History rows
 * and the Integration table's LastRun, so an admin can tell whether the scheduled sync is
 * actually running and succeeding.
 * @export
 * @interface WebApiAdminDtoSyncActivityDto
 */
export interface WebApiAdminDtoSyncActivityDto {
    /**
     * One summary per integration type that logs sync runs ("Fortnox", "Spiris")
     * @type {Array<WebApiAdminDtoIntegrationSyncSummaryDto>}
     * @memberof WebApiAdminDtoSyncActivityDto
     */
    byIntegration?: Array<WebApiAdminDtoIntegrationSyncSummaryDto> | null;
    /**
     * The most recent sync runs across all integrations, newest first
     * @type {Array<WebApiAdminDtoRecentSyncRunDto>}
     * @memberof WebApiAdminDtoSyncActivityDto
     */
    recentRuns?: Array<WebApiAdminDtoRecentSyncRunDto> | null;
    /**
     * Active integrations that have not synced within the last 24 hours
     * @type {Array<WebApiAdminDtoStaleIntegrationDto>}
     * @memberof WebApiAdminDtoSyncActivityDto
     */
    staleIntegrations?: Array<WebApiAdminDtoStaleIntegrationDto> | null;
}

/**
 * Check if a given object implements the WebApiAdminDtoSyncActivityDto interface.
 */
export function instanceOfWebApiAdminDtoSyncActivityDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoSyncActivityDtoFromJSON(json: any): WebApiAdminDtoSyncActivityDto {
    return WebApiAdminDtoSyncActivityDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoSyncActivityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoSyncActivityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'byIntegration': !exists(json, 'byIntegration') ? undefined : (json['byIntegration'] === null ? null : (json['byIntegration'] as Array<any>).map(WebApiAdminDtoIntegrationSyncSummaryDtoFromJSON)),
        'recentRuns': !exists(json, 'recentRuns') ? undefined : (json['recentRuns'] === null ? null : (json['recentRuns'] as Array<any>).map(WebApiAdminDtoRecentSyncRunDtoFromJSON)),
        'staleIntegrations': !exists(json, 'staleIntegrations') ? undefined : (json['staleIntegrations'] === null ? null : (json['staleIntegrations'] as Array<any>).map(WebApiAdminDtoStaleIntegrationDtoFromJSON)),
    };
}

export function WebApiAdminDtoSyncActivityDtoToJSON(value?: WebApiAdminDtoSyncActivityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'byIntegration': value.byIntegration === undefined ? undefined : (value.byIntegration === null ? null : (value.byIntegration as Array<any>).map(WebApiAdminDtoIntegrationSyncSummaryDtoToJSON)),
        'recentRuns': value.recentRuns === undefined ? undefined : (value.recentRuns === null ? null : (value.recentRuns as Array<any>).map(WebApiAdminDtoRecentSyncRunDtoToJSON)),
        'staleIntegrations': value.staleIntegrations === undefined ? undefined : (value.staleIntegrations === null ? null : (value.staleIntegrations as Array<any>).map(WebApiAdminDtoStaleIntegrationDtoToJSON)),
    };
}

